/* eslint-disable max-len */
import images from 'assets/images';
import Breadcrumb from 'components/App/Breadcrumb';
import Button from 'components/App/Button';
import Card from 'components/App/Card';
import Meta from 'components/App/Meta';
import DiscoverPlaceInformation from 'components/DiscoverPlaceInformation';
import DiscoveryPlaceReviews from 'components/DiscoveryPlaceReviews';
import ModalRequestAction from 'components/Modals/ModalRequestAction';
import ENDPOINT from 'constants/endPoint';
import { themeColor } from 'constants/index';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Container, Spinner } from 'reactstrap';
import { useBoolean } from 'usehooks-ts';
import { showSuccess } from 'utils';

const BREADCRUMB_LIST = [
  {
    name: 'Khám phá',
    isActive: false,
    link: '', // TODO: ADD ROUTE WHEN HAVE LINK
  },
  {
    name: 'Danh sách điểm khám phá',
    isActive: false,
    link: ENDPOINT.MANAGER_DISCOVERY_PLACE,
  },
  {
    name: 'Chi tiết điểm khám phá',
    isActive: true,
    link: '',
  },
];

function ManagerDiscoveryPlaceDetails(props) {
  const {
    discoverPlaceDetails,
    discoverPlaceDetailsLoading,
    actionGetDiscoverPlaceDetails,
    actionCleanupDiscoverPlaceDetails,

    reviews,
    reviewsLoading,
    actionGetDiscoveryReviews,
    actionCleanupDiscoverReviews,

    actionDeleteDiscoveryReview,
    isDeleteDiscoveryReviewLoading,

    deleteLoading,
    actionDeleteDiscoverPlace,
  } = props;

  const reviewsTotalPages = Math.ceil(reviews.total / 10);

  const params = useParams();
  const history = useHistory();

  const { id } = params;

  const [reviewState, setReviewState] = useState({
    search: '',
    fromDate: '',
    toDate: '',
    page: 1,
  });

  const [reviewDetail, setReviewDetail] = useState(null);

  const {
    value: isOpenModalDeleteReview,
    setTrue: onOpenModalDeleteReview,
    setFalse: onCloseModalDeleteReview,
    toggle: onToggleModalDeleteReview,
  } = useBoolean(false);

  const {
    value: isOpenModalDeletePlace,
    setTrue: onOpenModalDeletePlace,
    setFalse: onCloseModalDeletePlace,
    toggle: onToggleModalDeletePlace,
  } = useBoolean(false);

  const onConfirmDeleteReview = useCallback(() => {
    actionDeleteDiscoveryReview({
      id: reviewDetail.id,
      callback: () => {
        onCloseModalDeleteReview();

        showSuccess(
          reviewDetail.deletedAt ?
            'Khôi phục đánh giá thành công'
            : 'Xóa đánh giá thành công');
      },
    });
  }, [
    actionDeleteDiscoveryReview,
    onCloseModalDeleteReview,
    reviewDetail?.deletedAt,
    reviewDetail?.id,
  ]);

  useEffect(() => {
    actionGetDiscoverPlaceDetails(id);

    return () => {
      actionCleanupDiscoverPlaceDetails();
    };
  }, [actionCleanupDiscoverPlaceDetails, actionGetDiscoverPlaceDetails, id]);

  useEffect(() => {
    actionGetDiscoveryReviews({
      place: id,
      page: 1,
      limit: 10,
    });

    return () => {
      actionCleanupDiscoverReviews();
    };
  }, [actionCleanupDiscoverReviews, actionGetDiscoveryReviews, id]);

  if (discoverPlaceDetailsLoading) {
    return (
      <div style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      >
        <Spinner />
      </div>
    );
  }

  if (!discoverPlaceDetails._id && !discoverPlaceDetailsLoading) {
    return (
      <>
        <div className="page-content">
          <Meta name="Chi tiết điểm khám phá" />

          <Container fluid>
            <Breadcrumb
              pageTitle="Danh sách điểm khám phá"
              breadcrumbList={BREADCRUMB_LIST}
            />

            Không tìm thấy điểm khám phá
          </Container>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-content">
        <Meta name="Chi tiết điểm khám phá" />

        <Container fluid>
          <Breadcrumb
            pageTitle="Chi tiết điểm khám phá"
            breadcrumbList={BREADCRUMB_LIST}
          />

          <DiscoverPlaceInformation
            name={discoverPlaceDetails.name}
            address={discoverPlaceDetails.address}
            description={discoverPlaceDetails.description}
            serviceHours={`${discoverPlaceDetails.hoursOfService.from} - ${discoverPlaceDetails.hoursOfService.to}`}
            priceRange={discoverPlaceDetails.priceRange.from || discoverPlaceDetails.priceRange.from === 0 ? `${discoverPlaceDetails.priceRange.from} VNĐ` : 'N/A'}
            phone={discoverPlaceDetails.phoneNumber}
            contactName={discoverPlaceDetails.contactName}
            contactEmail={discoverPlaceDetails.contactEmail}
            createdAt={moment(discoverPlaceDetails.createdAt).format('YYYY-MM-DD')}
            mainImage={discoverPlaceDetails.previewImage}
            images={discoverPlaceDetails.images}
          />

          <DiscoveryPlaceReviews
            loading={reviewsLoading}
            overallRating={discoverPlaceDetails.ratingOverview ?? 0}
            totalReviews={discoverPlaceDetails.totalReviews ?? 0}
            ratingBreakdown={{
              5: discoverPlaceDetails.total5starReviews ?? 0,
              4: discoverPlaceDetails.total4starReviews ?? 0,
              3: discoverPlaceDetails.total3starReviews ?? 0,
              2: discoverPlaceDetails.total2starReviews ?? 0,
              1: discoverPlaceDetails.total1starReviews ?? 0,
            }}
            reviews={reviews.data.map((item) => ({
              id: item._id,
              userName: item.user.displayName || item.user.fullName,
              star: item.star,
              title: item.title,
              content: item.content,
              images: item.images,
              visitDate: item.comeAt,
              likes: 0,
              dislikes: 0,
              deletedAt: item.deletedAt,
            }))}
            currentPage={reviewState.page}
            totalPages={reviewsTotalPages}
            onSearch={({ query, fromDate, toDate }) => {
              actionGetDiscoveryReviews({
                place: id,
                page: 1,
                limit: 10,
                q: query,
                from: moment(fromDate).isValid()
                  ? moment(fromDate).format('YYYY-MM-DD')
                  : null,
                to: moment(toDate).isValid()
                  ? moment(toDate).format('YYYY-MM-DD')
                  : null,
              });
            }}
            onReset={() => {
              actionGetDiscoveryReviews({
                place: id,
                page: 1,
                limit: 10,
              });
            }}
            onDeleteReply={(itemId, item) => {
              setReviewDetail(item);
              onOpenModalDeleteReview();
            }}
            onPageChange={(selected) => {
              setReviewState({ ...reviewState, page: selected });

              actionGetDiscoveryReviews({
                place: id,
                page: selected,
                limit: 10,
              });
            }}
          />

          <Card className="mt-24">
            <div className="d-flex justify-content-end gap-4">
              <Button
                color={themeColor.DANGER}
                outline
                type="button"
                style={{ border: 'none' }}
                onClick={onOpenModalDeletePlace}
              >
                Xoá điểm khám phá
              </Button>

              <Link to={`/manager-discovery/place/edit/${id}`}>
                <Button>
                  Cập nhật
                </Button>
              </Link>
            </div>
          </Card>
        </Container>
      </div>

      <ModalRequestAction
        isOpen={isOpenModalDeleteReview}
        icon={images.modalGarbageCan.default}
        textRequest={`Bạn có chắc chắn muốn ${reviewDetail?.deletedAt ? 'khôi phục' : 'xóa'} \n đánh giá này không?`}
        onToggle={onToggleModalDeleteReview}
        onCloseModal={onCloseModalDeleteReview}
        onConfirm={onConfirmDeleteReview}
        isLoadingConfirm={isDeleteDiscoveryReviewLoading}
      />

      <ModalRequestAction
        isOpen={isOpenModalDeletePlace}
        icon={images.modalGarbageCan.default}
        textRequest={'Bạn có chắc chắn muốn xóa \n điểm khám phá này không?'}
        onToggle={onToggleModalDeletePlace}
        onCloseModal={onCloseModalDeletePlace}
        onConfirm={() => {
          actionDeleteDiscoverPlace({
            id,
            callback: () => {
              onCloseModalDeletePlace();
              showSuccess('Xóa điểm khám phá thành công');
              history.push('/manager-discovery/place');
            },
          });
        }}
        isLoadingConfirm={deleteLoading}
      />
    </>
  );
}

ManagerDiscoveryPlaceDetails.propTypes = {
  discoverPlaceDetails: PropTypes.instanceOf(Object).isRequired,
  discoverPlaceDetailsLoading: PropTypes.bool.isRequired,
  actionGetDiscoverPlaceDetails: PropTypes.func.isRequired,
  actionCleanupDiscoverPlaceDetails: PropTypes.func.isRequired,

  reviews: PropTypes.instanceOf(Object).isRequired,
  reviewsLoading: PropTypes.bool.isRequired,
  actionGetDiscoveryReviews: PropTypes.func.isRequired,
  actionCleanupDiscoverReviews: PropTypes.func.isRequired,

  actionDeleteDiscoveryReview: PropTypes.func.isRequired,
  isDeleteDiscoveryReviewLoading: PropTypes.bool.isRequired,

  deleteLoading: PropTypes.bool.isRequired,
  actionDeleteDiscoverPlace: PropTypes.func.isRequired,
};

export default ManagerDiscoveryPlaceDetails;
